module.exports = __webpack_public_path__ + "static/masku-a8132818a5986c5bba536a4bb1aadc3c.jpg";